/*
This script continously loads post as the user scrolls the page. It uses the IntersectionObserver API to detect when the last post is in view. When the last post is in view, it fetches the next page and appends the posts to the page. It then checks if there is a next page and if there is, it continues to observe the last post. If there is no next page, it disconnects the observer. 

Importantly, for this script to work, it requires that each card have the `post` class and that the card container have the `gh-postfeed` class
*/

let link = document.querySelector('link[rel="next"]')?.getAttribute('href');

// End-of-posts animation function
function showEndOfPostsAnimation() {
    const postFeed = document.querySelector('.gh-postfeed');
    if (!postFeed) return;
    
    // Create end-of-posts section
    const endSection = document.createElement('div');
    endSection.className = 'potred-end-of-posts';
    endSection.innerHTML = `
        <div class="flex flex-col items-center gap-4 py-8 mt-8" style="
            padding: 3rem 0;
            text-align: center;
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease-out;
        ">
            <div class="relative w-full max-w-2xl">
                <div class="section-end-line" style="
                    width: 100%;
                    max-width: 32rem;
                    height: 1px;
                    background: linear-gradient(90deg, transparent, #ea580c80, transparent);
                    margin: 0 auto 1.5rem;
                    transform: scaleX(0);
                    transition: transform 1.2s cubic-bezier(0.4, 0, 0.2, 1);
                "></div>
                
                <div class="section-end-ornament" style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 4px;
                    margin-bottom: 1rem;
                    opacity: 0;
                    transform: scale(0);
                    transition: all 0.6s ease-out 0.8s;
                ">
                    <div style="
                        width: 4px;
                        height: 4px;
                        background: linear-gradient(45deg, #ea580c, #dc2626);
                        border-radius: 50%;
                        transform: scale(0);
                        animation: ornamentPop 0.4s ease-out 1s forwards;
                    "></div>
                    <div style="
                        width: 4px;
                        height: 4px;
                        background: linear-gradient(45deg, #ea580c, #dc2626);
                        border-radius: 50%;
                        transform: scale(0);
                        animation: ornamentPop 0.4s ease-out 1.1s forwards;
                    "></div>
                    <div style="
                        width: 4px;
                        height: 4px;
                        background: linear-gradient(45deg, #ea580c, #dc2626);
                        border-radius: 50%;
                        transform: scale(0);
                        animation: ornamentPop 0.4s ease-out 1.2s forwards;
                    "></div>
                </div>
                
                <div class="section-end-message" style="
                    background: rgba(255,255,255,0.1);
                    backdrop-filter: blur(8px);
                    border: 1px solid rgba(234, 88, 12, 0.2);
                    border-radius: 12px;
                    padding: 1rem 1.5rem;
                    display: inline-block;
                    opacity: 0;
                    transform: translateY(10px);
                    transition: all 0.5s ease-out 1.3s;
                ">
                    <p style="
                        background: linear-gradient(45deg, #ea580c, #dc2626);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        background-clip: text;
                        font-size: 1.125rem;
                        font-weight: 600;
                        margin: 0 0 0.25rem 0;
                    ">
                        That's all the posts for now
                    </p>
                    <p style="
                        color: #ea580c80;
                        font-size: 0.875rem;
                        margin: 0;
                    ">
                        Check back soon for more content
                    </p>
                </div>
            </div>
        </div>
    `;
    
    // Add CSS animations if not already added
    if (!document.getElementById('potred-end-animations')) {
        const style = document.createElement('style');
        style.id = 'potred-end-animations';
        style.textContent = `
            @keyframes ornamentPop {
                0% { transform: scale(0); }
                50% { transform: scale(1.2); }
                100% { transform: scale(1); }
            }
        `;
        document.head.appendChild(style);
    }
    
    // Append to post feed
    postFeed.appendChild(endSection);
    
    // Trigger animations
    setTimeout(() => {
        const container = endSection.querySelector('.flex');
        const line = endSection.querySelector('.section-end-line');
        const ornament = endSection.querySelector('.section-end-ornament');
        const message = endSection.querySelector('.section-end-message');
        
        if (container) {
            container.style.opacity = '1';
            container.style.transform = 'translateY(0)';
        }
        
        if (line) {
            line.style.transform = 'scaleX(1)';
        }
        
        setTimeout(() => {
            if (ornament) {
                ornament.style.opacity = '1';
                ornament.style.transform = 'scale(1)';
            }
        }, 800);
        
        setTimeout(() => {
            if (message) {
                message.style.opacity = '1';
                message.style.transform = 'translateY(0)';
            }
        }, 1300);
    }, 100);
}

// Fetch and parse next page
async function getNextPage(url) {
    try {
        const res = await fetch(url);
        
        if (!res.ok) {
            throw new Error('Failed to fetch page')
        }
        
        const nextPageHtml = await res.text();
        const parser = new DOMParser();
        const parsed = parser.parseFromString(nextPageHtml, 'text/html');
        const posts = parsed.querySelectorAll('.post');
        const nextLink = parsed.querySelector('link[rel="next"]')?.getAttribute('href');
        
        return {posts, nextLink}

    } catch (error) {
        throw new Error(error)
    }
}

export default function infiniteScroll() {
    
    if (!link) { return; }

    const options = {
        // When the last card is within a 150px of the viewport, fetch the next page. This provides a smoother transition between pages 
       rootMargin: '150px',
    }

    const callback = (entries, observer) => {
        try {
            entries.forEach(entry => {
            
                if (entry.isIntersecting) {
                    
                    if (link) {
                        getNextPage(link).then(({posts, nextLink}) => {
                            posts.forEach(post => {
                                document.querySelector('.gh-postfeed').append(post)
                            })

                            if (nextLink) {
                                link = nextLink;
                                observer.observe(document.querySelector('.post:last-of-type'))
                            } else {
                                observer.disconnect()
                                // Show end-of-posts animation when no more pages available
                                showEndOfPostsAnimation();
                            }
                        })
                    }
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    let observer = new IntersectionObserver(callback, options);

    const lastPost = document.querySelector('.post:last-of-type');
    if (lastPost) {
        observer.observe(lastPost);
    }

}